/* eslint-disable no-template-curly-in-string */
import cookies from 'js-cookie';
import dayjs from 'dayjs';
import { versionCompare } from '@kibt/web-utils/version';
import { addParam, getQueryParams } from '@/utils/util';
import {RankInfoType} from './components/rank/types';
import {RelatedRankMapItem, TimeInfoItem, RankItemType, rewardItemType, CommonReward, CurAnchorInfo, ICollectMissionData, SupecialRank} from './service';
import {GiftInfoValue} from './types/gift-pack';
import { TCardRewardStatus } from './hooks/mission/collect/useCurrentCollectCardStatus';

export const BUCKET_MAP = {
    br: 'k_342128',
    tur: 'k_342127',
    pak: 'k_342126',
    in: 'k_342125',
    egy: 'k_342124',
    spa: 'k_362594',
} as const;

export const getBucketText = (bucket: string) => {
    // eslint-disable-next-line no-underscore-dangle
    return window?.__$k18n({id: BUCKET_MAP[bucket as keyof typeof BUCKET_MAP]}) || '';
};

export const showD = ['MEDAL', 'ENTRY_SPECIAL_EFFECTS', 'PRIVILEGE'];

export const RankIcon = {
    score: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/global-midyear/v2/score-l3.png',
    score_h: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/global-midyear/v2/score-l2.png',
    diamond: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/act/diamond.png',
    diamond_l: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/diamond-v.png',
};
export const rankAvator = {
    1: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/avatar1.png',
    2: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/avatar-v2.png',
    3: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/avatar-v3.png',
};
export const oldRankNum = {
    1: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/rank1.png',
    2: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/rank2.png',
    3: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/rank3.png',
};
export const rankNum = {
    1: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/global-midyear/v2/rank1_2.png',
    2: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/global-midyear/v2/rank2_2.png',
    3: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/global-midyear/v2/rank3_2.png',
};
export const formatList = <T extends RankInfoType | {}>(obj: T ): T | {} => {
    if (!obj) return {};
    if (!('userId' in obj)) return obj;
    const score = obj.score || 0;
    obj.formatScore = score.toString().length > 6 ? `${(+score / 1000).toFixed(2)}k` : score;
    return obj;
};

export const hyId = 'global-midyear2023';
export const pageRatio = 0.62;
// 主页分享路径
export const PAGE_SHARE_PARAMS = `&hyId=${hyId}&source=WEB_SHARE&liveWHRatio=${pageRatio}`;

// 主页端外打开路径
export const PAGE_BACK_FLOW_HOME = `/global-midyear/home?hyId=${hyId}&liveWHRatio=${pageRatio}&source=SHARE&need_login=true&loginCheck=1&__launch_options__=%7B%22topBarPosition%22%3A%22fixed%22%7D`;

export const competitionType:Record<string, string> = {
    '2': 'FINAL',
    '1': 'OPPOSE',
    '0': 'PRE',
};

/**
 *
 * @param arr json对象
 * @param onlyKey 去重标识
 * @returns
 */
export const removeDuplicate = <K extends keyof RelatedRankMapItem>(arr: RelatedRankMapItem[], onlyKey: K): RelatedRankMapItem[] => {
    const map = new Map<any, boolean>();
    const newArr: RelatedRankMapItem[] = [];
    if (!arr.length) return newArr;

    arr.forEach((item: RelatedRankMapItem) => {
        let key: any = '';
        if (typeof item === 'object') {
            key = item[onlyKey];
        } else {
            key = onlyKey;
        }
        if (!map.has(key)) {
            map.set(key, true);
            newArr.push(item);
        }
    });

    return newArr;
};

export const formatScore = (num:number|string) => {
    return num.toString().length > 6 ? `${(+num / 1000).toFixed(2)}k` : num;
};
export const formateDate = (str:string) => {
    return str.slice(5, 10).split('-').reverse().join('/');
};
export const generateCompetitionTime = (obj:TimeInfoItem) => {
    return `${formateDate(obj.startTime)}-${formateDate(obj.endTime)}`;
};

export const LOAD_STATUS = {
    loading: 'loading',
    success: 'success',
    error: 'error',
    crossBucket: 'crossBucket',
};

export const mockPkData = {
    'userInfo': {
        'rank': '',
        'userId': '',
        'userName': 'xxxxxxxx',
        'score': 0,
        'headUrl': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/global-midyear/v2/avatar.png',
        'contributeRankList': [],
        'followed': false,
        'isLiving': false,
        'isMyself': false,
    },
    'opposerInfo': {
        'rank': '',
        'userId': '',
        'userName': 'xxxxxx',
        'score': 0,
        'headUrl': 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/global-midyear/v2/avatar.png',
        'contributeRankList': [],
        'followed': false,
        'isLiving': false,
        'isMyself': false,
    },
};

// 判断ud
/**
 *
 * @param info 个人信息
 * @param rewrads 奖励信息
 * @param promoteNum 晋级名次
 * @param promoteRank 符合晋级的用户
 * @param specialRank object对象
 * @returns
 */
export const getBottomInfoTip = (info:RankItemType, rewrads:rewardItemType[], promoteNum:number, specialRank:SupecialRank) => {
    const score = Number(info.score);
    const newRankStr = String(info.rank).replace(/\D+/g, '');
    const rank = Number(newRankStr);
    // 判断是否在奖励区间
    const rewardTarget = rewrads.find(item => item.endPosition >= rank && rank >= item.startPosition);
    const lastReward = rewrads[rewrads.length - 1] || {newRewards: [{scoreThreshold: 0}]};
    // 存在奖励区间内
    if (rewardTarget){
        try {
            const newRewards = rewardTarget.newRewards;
            if (newRewards[0].scoreThreshold && newRewards[0]?.scoreThreshold > score){
            // 未达到获奖门槛
                return {
                    bottomRewards: newRewards,
                    bottomText: `再收集${newRewards[0].scoreThreshold - score}可获得{xxx}奖励`,
                    type: 1,
                    disScore: newRewards[0].scoreThreshold - score,
                };
            }
            // 下一名用户信息
            const curAnchorNextRankScore = specialRank.curAnchorNextRankScore;
            // 当前主播积分 - 下一名积分 = bonus
            const bonusNum = (score - Number(curAnchorNextRankScore)) * (newRewards[0]?.percentageOfDiffScore||0) / 100;
            const newBonusNum = (newRewards[0]?.maxUnitCalByDiffScore||0) <= bonusNum ? (newRewards[0]?.maxUnitCalByDiffScore||0) : bonusNum;

            // 达到获奖门槛
            return {
                bottomRewards: newRewards,
                bottomText: `当前可获得定额奖励{xxx},bonus奖励${newBonusNum},领先下一名越多,bonus奖励越高`,
                type: 2,
                bouns: Math.round(newBonusNum),
            };

        } catch (error) {
            return {
                bottomRewards: [],
                bottomText: '',
                type: '',
            };
        }

    }

    // 奖励区间用户信息
    const endPosittionScore = specialRank.endPosittionScore;

    if (rank <= promoteNum && rank > lastReward.endPosition ){
        // 在晋级区间但未进入奖励区间
        return {
            bottomRewards: lastReward.newRewards,
            type: 1,
            disScore: Number(endPosittionScore) - score + 1,
        };
    }
    // 晋级用户积分
    const preToOpposeScore = specialRank.preToOpposeScore;
    if (preToOpposeScore){
        const disScore = Number(preToOpposeScore) - score;
        return {
            bottomRewards: [],
            disScore: disScore + 1, // 需要超过前一名，所以积分得+1
            type: 3,
        };
    }
    const finallyScore = Number(endPosittionScore) - score > 0 ? Number(endPosittionScore) - score : 0;
    // 不存在晋级用户的场景，则使用兜底
    return {
        bottomRewards: lastReward.newRewards,
        type: 1,
        disScore: finallyScore + 1,
    };
};

// 生成奖励标题
export const generateRewardText = (obj:rewardItemType) => {
    if (obj.startPosition === obj.endPosition){
        return obj.startPosition;
    }
    return `${obj.startPosition} - ${obj.endPosition}`;
};

// 获取对应分数的奖励
/**
 *
 * @param winnerRewardMap 奖励
 * @param score 分数
 */
const getRewardFromScore = (winnerRewardMap:Record<string, CommonReward[]>, score:string|number) => {

    const rewards:number[] = Object.keys(winnerRewardMap).sort((a, b)=>Number(a) - Number(b)).map(Number);
    // 最低奖励
    const tempData = {
        tempKey: String(rewards[0]),
        tempScore: rewards[0],
    };
    let rewardTraget:CommonReward[] = [];
    // 获取积分对应奖励索引
    let targetRewardIdx = 0;
    for (let i = 0; i < rewards.length; i++) {
        if (Number(score) >= Number(rewards[i])){
            targetRewardIdx = i;
        }
    }
    tempData.tempKey = String(rewards[targetRewardIdx]);
    tempData.tempScore = rewards[targetRewardIdx];
    rewardTraget = winnerRewardMap[String(rewards[targetRewardIdx])] || [];
    return {
        tempData,
        rewardTraget,
    };
};

// 生成pk底部信息
export const getPkBottomInfoTip = (curAnchorInfo:CurAnchorInfo, winnerRewardMap:Record<string, CommonReward[]>) => {
    const {info = {score: 0}, opposerScore = 0} = curAnchorInfo;
    // 当前主播积分
    const infoScore = Number(info.score);
    // 对手积分
    const opposeScore = Number(opposerScore);

    // 未获胜
    if (infoScore <= opposeScore ){
        // 计算获胜积分的对应的奖励档位
        const {tempData, rewardTraget} = getRewardFromScore(winnerRewardMap, opposeScore);
        // 对手积分高，奖励积分没达到
        if (opposeScore < tempData.tempScore){
            // 距离奖励门槛的差值
            const disScore = tempData.tempScore - infoScore;
            return {
                bottomRewards: rewardTraget || [],
                disScore,
                type: 1,
            };
        }
        // 达到奖励门槛
        // 距离对手的差值
        const disScore = opposeScore - infoScore + 1;
        // 计算超过对手积分对应的档位
        const aboveData = getRewardFromScore(winnerRewardMap, opposeScore + 1);
        return {
            bottomRewards: aboveData.rewardTraget || [],
            disScore,
            type: 1,
        };

    }
    // 已获胜
    // 计算自己积分对应档位
    const newData = getRewardFromScore(winnerRewardMap, infoScore);
    // 未达到奖励门槛
    if (infoScore < newData.tempData.tempScore){
        const disScore = newData.tempData.tempScore - infoScore;
        return {
            bottomRewards: newData.rewardTraget || [],
            disScore,
            type: 1,
        };
    }
    const arr = Object.keys(winnerRewardMap).sort((a, b) => Number(b) - Number(a));
    // 达到最高奖励门槛
    if (newData.tempData.tempKey === arr[0]){
        return {
            bottomText: '',
            bottomRewards: [],
            type: '',
        };
    }
    // 获取下一等级奖励 (arr倒序)
    const idx = arr.findIndex(item => item === newData.tempData.tempKey);
    const rewards = winnerRewardMap[arr[idx - 1]];
    return {
        disScore: Number(arr[idx - 1]) - infoScore,
        bottomRewards: rewards,
        type: 1,
    };
};

// 获取元素距离页面顶部的距离
export const getDistanceFromTop = (element: HTMLElement): number => {
    let distance = 0;
    if (element.offsetParent) {
        while (element.offsetParent) {
            distance += element.offsetTop;
            element = element.offsetParent as HTMLElement;
        }
    } else {
        distance = element.offsetTop;
    }
    return distance;
};
// 判断页面滚动是否超过一屏
export function isPageScrollOverScreen() {
    const winHeight = window.innerHeight;
    const scrollTop = window.scrollY || window.pageYOffset;
    return scrollTop > winHeight;
}
// 按照给定数组的顺序进行排列
export const sortGroupArr = (originArr:RelatedRankMapItem[], referArr:string[]) => {
    return referArr.map(item => {
        const idx = originArr.findIndex(oItem=>oItem.period === item);
        return originArr[idx];
    });
};

// 集卡任务文案

export const COLLECT_COPY_WRITING_LIST: Record<TCardRewardStatus, string[]> = {
    'NOT_START': [
        // 'Complete tasks to get shards;',
        'k_341719',
        // 'Every ${0} shards can be combined into a secret treasure key and get stage rewards;',
        'k_341720',
        // 'Secret treasure keys can be used to divide the final prize pool, the more keys, the more rewards',
        'k_341721',
    ],
    'CALCULATING': [
        // 'Secret treasure keys can be used to divide the final prize pool, the more keys, the more rewards',
        'k_341721',
    ],
    'REWARDED': [],
    'END': [],
    'NOOB_TUTORIAL': [],
    'REWARDING': [],
};

export const COLLECT_RULES_DETAILS_COPY_WRITING = [
    'k_341719',
    'k_341720',
    'k_341721',
];

export const getCollectTaskTipsCopyWriting = (type: keyof ICollectMissionData['cardInfo']['cardCollectDetail']) => {
    switch (type) {
        case 'DAILY_GIFT_CARD':
            return 'k_333153'; // 每日首次赠送活动礼物即可获得1块碎片
        case 'SEND_GIFT_CARD':
            return 'k_333155';// 单次赠送活动礼物大于${0}钻石，即可获得1块碎片
        case 'DAILY_PK_CARD':
            return 'k_333157'; // 每日首次开PK（不提前逃跑）即可获得1块碎片
        case 'PK_CARD':
            return 'k_333158'; // PK获胜且PK积分大于${0}，即可获得1块碎片
        case 'FREE':
            return 'k_333149'; // 每日可免费随机领取1块碎片
        default:
            return '';
    };
};

export const getValFromObj = (obj:Record<string, GiftInfoValue>)=>{
    const arr = Object.values(obj);
    return arr[arr.length - 1]?.hourlyPackNum || 0;
};

// 比较版本
export const versionCompareFunc = (version:string) => {
    const appver = cookies.get('appver') || '0';
    return versionCompare(appver, version) >= 0;
};

export const formatTime = (num: number) => {
    const numString = num.toString();
    return numString.length < 2 ? `0${numString}` : numString;
};

// 构造格式
export const formateDay = (str:string) => {
    const YYYY = str.slice(0, 4);
    const MM = str.slice(4, 6);
    const DD = str.slice(6, 8);
    return `${YYYY}-${MM}-${DD}`;
};
// 解除构造
export const secureDate = (str:string) => {
    return str.split('/').reverse().join('-');
};

// 构造日期tab
export const generateDateTab = (startTime:string, endTime:string, formatType = 'DD/MM/YYYY') => {
    const startDay = dayjs(startTime);
    const endDay = dayjs(endTime);
    const length = endDay.diff(startDay, 'day');
    const list = [];
    for (let i = 0; i < length + 1; i++) {
        list.push({
            key: startDay.add(i, 'day').format('YYYY-MM-DD'),
            label: startDay.add(i, 'day').format(formatType),
        });
    }
    return list;
};

// 替换url地址
export const replaceUrlAction = ( obj:Record<string, string>) => {
    const query = getQueryParams();
    const newQuery = {
        ...query,
        ...obj,
    };
    const newUrl = addParam(window.location.origin + window.location.pathname, newQuery);
    window.history.replaceState({}, '', newUrl);
};

// 构造新奖励结构
export const formatReward = (arr:CommonReward[]):CommonReward[] => {
    return arr.map(item => {
        return {
            ...item,
            picUrl: item.icon,
            type: item.rewardType,
        };
    });
};

// 根据奖励进行聚合
export const generateNewReward = (tempArr: CommonReward[]) => {
    const arr = tempArr.filter(Boolean);
    const signObj: Record<string, number> = {};
    arr.forEach(ele => {
        const uniqueId = `${ele.rewardType}${ele.type}${ele.subType}${ele.subId}`;
        if (signObj[uniqueId]) {
            signObj[uniqueId] += ele.unit; // 增加奖品数量
        } else {
            signObj[uniqueId] = ele.unit;
        }
    });
    const res: any[] = [];
    for (const key in signObj) {
        const temp = arr.find(item => {
            const tempUniqueId = `${item.rewardType}${item.type}${item.subType}${item.subId}`;
            return tempUniqueId === key;
        });
        res.push({
            ...temp,
            unit: signObj[key],
        });
    }
    return res;
};

export const SHARE_CAPTION = 'KWAI GALA 2023';

export const GIFT_PACK = [
    {
        picUrl: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/gift1.png',
    },
    {
        picUrl: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/gift2.png',
    },
    {
        picUrl: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/gift3.png',
    },
    {
        picUrl: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/gift4.png',
    },
    {
        picUrl: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/midyear/v2/gift5.png',
    },
    {
        picUrl: 'https://cdn-static.kwai.net/kos/s101/nlav11312/live/global-midyear/v2/gift-6.png',
    },
];

export const COMPETTION_TYPE:Record<string, string> = {
    PRE: 'k_333050',
    OPPOSE: 'k_333052',
    FINAL: 'k_333054',
    ALL: '', // 删除，不会晋级全球赛
};
